import MarketingHeader from '../components/Layout/MarketingHeader';
import Footer from '../components/Footer/Footer';

/**
 * MarketingLayout — layout para páginas públicas/marketing.
 * Inclui MarketingHeader (sticky, transparente → branco) e Footer.
 */
export function MarketingLayout({ children }) {
  return (
    <>
      <MarketingHeader />
      <main>{children}</main>
      <Footer />
    </>
  );
}
